import axiosInstance from '../config/axios.js';

const BASE = '/paid-amount-settlements';

const paidAmountSettlementService = {
  getOpenDues: async (params = {}) => {
    const response = await axiosInstance.get(`${BASE}/open-dues`, { params });
    return response.data;
  },

  getMlCreationBlock: async () => {
    const response = await axiosInstance.get(`${BASE}/ml-creation-block`);
    return response.data;
  },

  previewAllocation: async (params = {}) => {
    const response = await axiosInstance.get(`${BASE}/preview-allocation`, { params });
    return response.data;
  },

  listRequests: async (params = {}) => {
    const response = await axiosInstance.get(`${BASE}/requests`, { params });
    return response.data;
  },

  getRequest: async (requestId) => {
    const response = await axiosInstance.get(`${BASE}/requests/${encodeURIComponent(requestId)}`);
    return response.data;
  },

  submitRequest: async (formData) => {
    const response = await axiosInstance.post(`${BASE}/requests`, formData, {
      headers: { 'Content-Type': undefined },
    });
    return response.data;
  },

  approveRequest: async (requestId, payload = {}) => {
    const response = await axiosInstance.post(
      `${BASE}/requests/${encodeURIComponent(requestId)}/approve`,
      payload,
    );
    return response.data;
  },

  rejectRequest: async (requestId, payload = {}) => {
    const response = await axiosInstance.post(
      `${BASE}/requests/${encodeURIComponent(requestId)}/reject`,
      payload,
    );
    return response.data;
  },
};

export default paidAmountSettlementService;
